import { useFormContext, useFormState } from "react-hook-form"
import { formatNumber } from "@/lib/helpers/formatNumber"
import CheckmarkCircle from "@/common/partials/checkmarkCircle"
import ErrorCircle from "@/common/partials/errorCircle"
import { ErrorMessage } from "@/components/checkout-form/errorMessage"

function CustomValue({ minAmount, hidden, id = "" }) {
  const { register, control } = useFormContext()
  const { errors, isValid } = useFormState({
    name: "customValue",
    control
  })

  const valid = isValid
  const invalid = !valid && errors?.customValue

  return (
    <div className={`mb-6 ${hidden ? "hidden" : ""}`}>
      <div className="relative flex">
        <input
          id={`customValue${id}`}
          {...register("customValue", {
            required: true,
            pattern: {
              value: /\d+/,
              message: "Beloppet får endast bestå av siffror"
            },
            min: {
              value: minAmount,
              message: `Beloppet måste vara minst ${formatNumber(minAmount)} kr`
            }
          })}
          type="number"
          className={[
            "number-appearance-none relative flex-grow w-full py-4 pl-12 xl:pl-14 pr-6 text-lg font-bold truncate bg-transparent outline-none sm:pr-8 px-3 text-black-100 transition-colors duration-200 border border-black-100/20 rounded focus:text-black focus:outline-none placeholder-black-50",
            valid && "border-green-100",
            invalid && "bg-red-20 border-red-100"
          ].join(" ")}
          placeholder="Valfritt belopp"
        />

        <div className="absolute flex items-center h-full ml-4 xl:ml-6 left-px custom-value-checkmark">
          {!invalid && <CheckmarkCircle selected={true} />}
          {invalid && <ErrorCircle />}
        </div>
        <label
          htmlFor="customValue"
          className="absolute flex items-center h-full pl-2 text-lg font-bold cursor-pointer right-4">
          kr
        </label>
      </div>
      <ErrorMessage name="customValue" />
    </div>
  )
}

export default CustomValue
